// components/CollectionSubtitles/CollectionConfirmModal.jsx
import React from "react";
import "./CollectionConfirmModal.css";
import { getLanguageName } from "../../utils/languages";

const CollectionConfirmModal = ({
  isOpen,
  onBack,
  onConfirm,
  collectionInfo,
  backLabel,
  confirmLabel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="ccm-overlay">
      <div onClick={(e) => e.stopPropagation()} className="ccm-modal">
        <div className="ccm-title">
          آیا زیرنویس‌های انتخابی با فیلم همخوانی دارد؟
        </div>

        {collectionInfo && (
          <div className="ccm-info">
            <span className="ccm-movie-name">{collectionInfo.movieName}</span>
            <div className="ccm-langs">
              <span className="ccm-lang">
                {getLanguageName(collectionInfo.langOne)}
              </span>
              <span className="ccm-lang">
                {getLanguageName(collectionInfo.langTwo)}
              </span>
            </div>
          </div>
        )}

        <div className="ccm-buttons">
          <button className="ccm-btn ccm-btn-back" onClick={onBack}>
            {backLabel || "↩️ برگشت"}
          </button>
          <button className="ccm-btn ccm-btn-confirm" onClick={onConfirm}>
            {confirmLabel || "✅ بله (تماشای فیلم)"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CollectionConfirmModal;
